import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { PointOfImpact } from "pages/DamageLocation/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionPointsOfImpactPhAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<PointOfImpact[]>(`pointsOfImpactPh-${sessionId}`, [])
);
export const pointsOfImpactPhAtom = createDerivedSessionAtom<PointOfImpact[]>(sessionPointsOfImpactPhAtom);
export const isValidPOIAtom = atom((get) => get(pointsOfImpactPhAtom).some((selected) => selected));

const sessionOtherVehiclePointsOfImpactAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<PointOfImpact[]>(`otherVehiclePointsOfImpact-${sessionId}`, [])
);
export const otherVehiclePointsOfImpactAtom = createDerivedSessionAtom<PointOfImpact[]>(
  sessionOtherVehiclePointsOfImpactAtom
);
export const isValidOtherPOIAtom = atom(() => true);
